import {Link, Typography, useMediaQuery, useTheme} from "@mui/material";

export function isEmpty(value) {
    return !value || (typeof value === 'object' && Object.keys(value).length === 0);
}

export function maybeSetParam(params, key, value) {
    if (!isEmpty(value)) {
        console.log(`Setting param ${key}`, value);
        if (Array.isArray(value)) {
            params.delete(key);
            params.delete(`${key}[]`);
            for (const v of value) {
                params.append(`${key}[]`, v);
            }
        } else {
            params.set(key, value);
        }
    } else {
        params.delete(key);
        params.delete(`${key}[]`);
    }
}

export function applyState(setFn, params, paramKey, attrValue) {
    if (isEmpty(attrValue)) {
        setFn(toParam(params.getAll(`${paramKey}[]`)));
    } else {
        maybeSetParam(params, paramKey, attrValue);
        setFn(toParam(attrValue));
    }
}

export function toParam(value) {
    if (value == null || value === '') {
        return [];
    }
    if (Array.isArray(value)) {
        return value;
    }
    if (value === 'Any') {
        return [];
    }
    return [value];
}

export function formatURL(url) {
    if (url == null || url === '') {
        return '';
    }
    return url.replace('http:', 'https:');
}

export function formatSuite(suite) {
    if (suite == null || suite === '') {
        return '';
    }
    return `, Suite ${suite}`;
}

export function formatAvailType(availType) {
    if (availType == null || availType === '') {
        return '';
    }
    return `For ${availType}, `;
}

export function maybeLinkToSpace(space, title, mini = false, dense = false) {
    const spaceDetailURL = `${window.location.origin}/space/?id=${space['Space_ID']}`;
    let fontScale = '1.6vw';
    if (useMediaQuery(useTheme().breakpoints.up('lg'))) {
        fontScale = '1.1vw';
    }
    const headline = <>
        <Typography gutterBottom={!dense} variant="h6"
                    sx={{fontSize: `clamp(14px, ${fontScale}, ${dense ? '1rem' : '1.1rem'})`}}>
            {title}
        </Typography>
        {!mini && (
            <Typography variant="subtitle1" color="text.secondary"
                        sx={{fontSize: `clamp(14px, ${fontScale}, 1rem)`}}>
                {`${space['Address']} ${space['City']}, ${space['State']} ${space['Zipcode']}`}
            </Typography>
        )}
    </>;
    if (space['Space_ID'] == null || space['Space_ID'] === '') {
        return headline;
    }
    return (
        <Link href={spaceDetailURL} underline='none'>{headline}</Link>
    );
}

export function maybeImgLinkToSpace(space, title) {
    if (space['Space_ID'] == null || space['Space_ID'] === '') {
        return (
            <img alt={`Image of ${title}`} src={formatURL(space['MainPhotoURL'])}
                 style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
        );
    }
    const spaceDetailURL = `${window.location.origin}/space/?id=${space['Space_ID']}`;
    return (
        <Link href={spaceDetailURL} underline='none' style={{width: '100%', height: '100%'}}>
            <img alt={`Image of ${title}`} src={formatURL(space['MainPhotoURL'])}
                 style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
        </Link>
    );
}
